<template>
  <div class="containers">
    <div>
      <div class="tui-box">
        <div>
          <div class="tui-address">
            <div
              v-if="address.length > 0"
              class="address-main"
              @click="tabAddress"
            >
              <div class="flex align-center">
                <img src="@/assets/icon/address.png" class="address-image" />
                <div>
                  <div class="tui-userinfo">
                    <span class="tui-name">{{
                      address[addressIndex].receiver_name
                    }}</span>
                    {{ address[addressIndex].receiver_mobile }}
                  </div>
                  <div class="tui-addr">
                    <span
                      >{{ address[addressIndex].address.province
                      }}{{ address[addressIndex].address.city
                      }}{{ address[addressIndex].address.district
                      }}{{ address[addressIndex].address.line1 }}</span
                    >
                  </div>
                </div>
              </div>
              <img src="@/assets/icon/right.png" class="right-image" />
            </div>
            <div v-else class="address-main" @click="tabAddress">
              <div class="flex align-center">
                <img src="@/assets/icon/address.png" class="address-image" />
                <span class="tui-none-addr"
                  >暂无收货地址，请先去添加收货地址</span
                >
              </div>
              <img src="@/assets/icon/right.png" class="right-image" />
            </div>
            <div class="tui-bg-img">
              <img src="@/assets/icon/bottom.png" />
            </div>
          </div>
        </div>
        <!-- <div class="tui-goods-title">
              {{ shopItem.storeName }}
            </div> -->
        <div
          class="tui-goods-item border-bottom"
          v-for="(it, i) in productList"
          :key="i"
        >
          <div class="flex">
            <img :src="it.goodsImgUrl" class="tui-goods-img" />
            <div class="tui-goods-center">
              <div>
                <div class="tui-goods-name">
                  {{ it.name }}
                </div>
              </div>
              <!--<div><span class="tag">限时秒杀</span></div>-->
              <div class="tui-price-right">
                <div class="goods-price">
                  <span>{{ it.point }}</span> 积分
                </div>
                <div>数量 x{{ it.number }}</div>
              </div>
              <div class="tui-goods-attr">
                {{ it.code }}
              </div>
            </div>
          </div>
          <!-- <div class="tui-goods-bottom">
                  <span>不支持7天无理由退换货</span>
                </div> -->
        </div>

        <div class="bg-white tui-top round-20 border-bottom">
          <div class="tui-padding tui-flex border-bottom">
            <div>支付方式：{{ payType }}</div>
            <div>合计：共{{ parseFloat(totalAmount) }}件</div>
            <div>
              应付积分：<span style="color: red">{{ totalPoint }}</span>
            </div>
          </div>
          <div class="tui-padding tui-flex border-bottom tui-tip">
            <div>正品货源</div>
            <div>免运费</div>
            <div>不支持发票</div>
          </div>
          <!-- <div class="tui-padding tui-flex">
                        <div class="flex align-center">
                            <span class="padding-right-xs">运费</span>
                            <van-icon class="icon-box-img" name="warn" size="16" color="#C9C9C9" @click="showModal('freight')"></van-icon>
                        </div>
                        <div>￥0.00</div>
                    </div> -->
          <!-- <div class="tui-padding tui-flex" @click="toMyCoupon">
                        <div>优惠券</div>
                        <div :class="hasCoupon ? 'text-theme' : ''">
                            {{ hasCoupon ? couponAmount : "没有可用优惠券" }}
                        </div>
                    </div> -->
          <div class="tui-padding tui-flex" v-if="this.OrderCount < 1">
            <div>请输入验证码</div>
            <div><input class="tui-input" type="text" v-model="code" maxlength="6"/></div>
            <van-button
              round
              color="var(--theme-color-main)"
              :disabled="disabled"
              type="primary"
              @click="sendcode"
              class="huoqu"
              >{{ vocode }}</van-button
            >
            <!-- <div  @click="sendMsg"></div> -->
          </div>
        </div>
        <div class="tui-zhuyis tui-padding border-bottom">
          <div>订单备注:</div>
          <input
            class="tui-inputs"
            placeholder="如需备注请在此填写"
            type="test"
            v-model="mark"
          />
        </div>

        <!-- <div class="tui-padding tui-flex bg-white tui-top round-20" @click="invoice">
                    <div>开具发票</div>
                    <div class="flex align-center">
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 0">无需发票</span>
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 1">电子发票</span>
                        <span class="pay-price padding-right-xs" v-if="invoiceType == 2">纸质发票</span>
                        <img src="@/assets/icon/right.png" class="right-image" />
                    </div>
                </div> -->

        <div class="tui-zhuyi tui-top">注意事项</div>
        <div class="tui-padding tui-flex bg-white round-20">
          <div class="flex align-center">
            <van-icon
              name="checked"
              size="20"
              color="#2283E2"
              v-if="agreement"
              @click="agreementBind"
            ></van-icon>
            <van-icon
              name="circle"
              size="20"
              color="#C9C9C9"
              v-if="!agreement"
              @click="agreementBind"
            ></van-icon>
            <span class="padding-left-xs" v-if="productList[0]&&productList[0].note">{{
              productList[0].note
            }}</span>
            <span class="padding-left-xs" v-else
              >兑换后订单不可取消或退货，无特殊情况预计3个工作日发出。勾选表示已同意该条款，感谢理解。</span
            >
            <!-- <span class="text-blue" @click="goProtocol"
                >《用户购买协议》</span
              > -->
          </div>
        </div>

        <div class="tui-zhuyi tui-top qy" v-if="qyshow">
          商品赠礼
          <div class="qybox" @click="qyModel = true">
            <div>
              赠权益：<span class="b">智家生态会员联合卡</span
              ><span class="c">*1</span>
            </div>
            <div class="bz">注：仅支持非付费会员体验卡用户限领一次</div>
          </div>
        </div>
      </div>

      <div class="tui-tabbar">
        <!--<div class="reminder">订单中包含秒杀商品，请在15:00内完成订单</div> -->
        <div class="flex justify-between align-center" style="padding: 10px 0">
          <div class="padding-left flex" style="text-align: right">
            <div class="tui-black">
              <span>共</span>
              <span class="tui-price-large">{{ parseFloat(totalAmount) }}</span
              >件
            </div>
            <div class="tui-black">
              <span>实付积分:</span>
              <span class="tui-price-large">{{ totalPoint }}</span>
            </div>
            <!-- <div class="tabbar-discounts">已优惠：{{ discountAmount }}</div> -->
          </div>
          <div class="tui-pr25">
            <van-button
              round
              block
              color="var(--theme-color-main)"
              type="primary"
              @click="subPay"
              >确认兑换</van-button
            >
            <!-- <van-loading  size="24px" vertical>加载中...</van-loading> -->
            <!-- <van-loading style="position:"  v-if="loading" color="#0094ff" /> -->
          </div>
        </div>
      </div>
      <van-popup v-model="show" closeable position="bottom">
        <div class="pay-header">
          <span class="pay-title">收银台</span>
          <span class="pay-price">订单总价</span>
          <span class="pay-money">{{ totalPoint }}积分</span>
          <!-- <span class="pay-time">
                    <van-count-down :time="time" format="DD 天 HH 时 mm 分 ss 秒" />
                </span> -->
        </div>
        <!-- <div class="pay-type">
          <div>支付方式</div>
        </div> -->

        <div class="flex justify-center">
          <div class="pay-but" @click="goPay()">
            确认支付{{ totalPoint }}积分
          </div>
        </div>
      </van-popup>
    </div>
    <van-dialog
      v-model="tipShow"
      title="下单须知"
      @confirm="tipShow = false"
      theme="round-button"
      confirm-button-color="var(--theme-color-main)"
      confirm-button-text="我知道了"
    >
      <div class="tui-receiving">
        受区域物流管控影响，部分订单发货时效或有延期，需以实际订单物流更新为准，请耐心等待，感谢您的理解
      </div>
    </van-dialog>

    <van-dialog
      v-model="qyModel"
      title="《智家会员生态联合卡声明》"
      @confirm="qyModel = false"
      theme="round-button"
      confirm-button-color="var(--theme-color-main)"
      confirm-button-text="我知道了"
    >
      <div class="tui-qy">
        <span>业务声明：</span> <br />
        积分商城为向智家会员提供更优质的购物体验，特别推出智家PLUS会员生态联合卡，全方位提升和丰富您在智家APP的购物特权。<br />
        <span>权益介绍及使用规则：</span><br />
        活动期间，在积分商城兑换指定商品可同步开通智家PLUS会员生态联合卡，权益包含专享会员折扣、专享购物卡券、尊享清洗优惠、专属客服服务四大权益。
        具体使用规则请下载智家APP并登录，在我的-PLUS会员中查看和使用。 <br />
        <span>有效期及其他：</span><br />
        智家会员生态联合卡自领取之日起1年内有效，请您合理保存、使用用户名和密码，若发现您的账户有违规行为，智家有权关闭您的PLUS会员开通资格、关停您已开通的PLUS会员服务。
        本活动最终解释权归海尔积分商城所有。<br />
        智家会员生态联合卡每个ID限领取一次，已经开通生态联合卡的用户及智家合伙人、智家客户等非普通用户身份不支持领取。
      </div>
    </van-dialog>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
  addOrderInfo,
  preOrder,
  searchUserAddrList,
  directSettle,
  queryMyCoupon,
  shoppingCartSettlement,
  createSpikeOrder,
  createJoinGroupOrder,
  haierCreateOrder,
  haierOrderCheckArea,
  haierOrderCheckQuantity,
  haierOrderPay,
  sendMsg,
  verifyCodeMemberReceived,
  haierOrderCount,
  haierOrderShoppingCart,
  haierDelShoppingCart,
  totalPoint,
  giftVoucherHaierCreateOrder,
  getUserInfo,
  getProductByGiftId,
} from "../../api/api";

// import {
//   createSpikeOrder,
//   addOrderInfo,
//   createJoinGroupOrder,
//   preOrder,
//   queryMyCoupon,
// } from "@/api/api";
// import orderGoods from "@/components/orderGoods.vue";
// import notData from "@/components/notData.vue";
// import orderPopup from "@/components/orderPopup.vue";
// import merge from "webpack-merge";
export default {
  components: {
    // notData,
    // orderGoods,
    // orderPopup,
  },
  data() {
    return {
      mark: "",
      userPoint: 0,
      // disabled: false,
      OrderCount: "",
      disabled: false,
      vocode: "发送验证码",
      totaltime: 60,
      code: "",
      parentOrderNo: "", // 父订单编号
      orderNo: "", //子订单编号
      time: "",
      show: false,
      catchtouchmove: false,
      productList: [], //商品列表
      totalPoint: 0,
      agreement: false, //服务协议
      hasCoupon: false,
      insufficient: false,
      modalName: "",
      deleteList: {},
      payIndex: 0,
      goodsList: [],
      invoiceType: 0,
      invoiceId: null,
      deliveryType: true,
      couponAmount: "",
      couponId: "",
      goodsId: "6635",
      goodsNum: "1",
      addressId: "118",
      groupProductType: "0",
      address: [],
      addressIndex: 0,
      shopInfo: {},
      property: "M,红色",
      discountAmount: 0.0,
      isPlus: 0, //是否plus
      totalAmount: 0,
      payType: "积分",
      tipShow: false,
      qyModel: false,
      qyshow: false,
      atimer: null,
      couponSource: 0,
      couponOrderType: 0,
      sourceCenter:'',
      query:{},
    };
  },
  created: function () {
    console.log(window.location.origin)
    const {sourceCenter} = this.$route.query;
    if (sourceCenter === 'article') {
      this.setQuery()
      if (this.query.access_token) {
        this.$cookies.set('hbscToken', this.query.access_token);
        sessionStorage.setItem('hbscToken', this.query.access_token);
        this.searchUserAddrList();
        this.getUserInfo();
      }
      this.getDetails();
    } else {
      this.orderInit();
    }
  },
  mounted() {
    this.addressIndex = this.$store.state.address;
    this.haierOrderCount();
    this.upperFindTotalPoint();
    this.saleTotalAmount = this.$route.query.saleTotalAmount;
  },
  methods: {
    setQuery(){
      const jsonObj = this.$route.query
      for (var key in jsonObj) {
        this.query[key] = jsonObj[key]==='undefined'||jsonObj[key]==='undefined'?'':jsonObj[key]
      }
    },
    async getUserInfo() {
      let params = {};
      const userInfo = await getUserInfo(params);
      if (userInfo.data) {
        this.$cookies.set("memberId", userInfo.data.idsUserId);
        sessionStorage.setItem("memberId", userInfo.data.idsUserId);
        this.$cookies.set("memberName", userInfo.data.loginName);
        sessionStorage.setItem("memberName", userInfo.data.loginName);
        this.$cookies.set("memberPhone", userInfo.data.cellphoene);
        sessionStorage.setItem("memberPhone", userInfo.data.cellphoene);
      }
    },
    getDetails() {
      const params = {
        activityNo: this.query.activityNo,
        productId: this.query.productId,
      };
      getProductByGiftId(params).then(res => {
        if (res.code === '0000') {
          this.productList = [res.data];
          this.orderInit();
        } else {
          this.$store.commit('hideLoading');
          this.$toast(res.msg);
        }
      });
    },
    orderInit() {
      if (this.query.sourceCenter !== 'article') {
        this.productList = this.$route.query.productList?JSON.parse(decodeURIComponent(this.$route.query.productList)):[]; //获取路由参数!
        if (this.productList[0].access_token && this.productList[0].access_token != "") {
          this.$cookies.set("hbscToken", this.productList[0].access_token);
          sessionStorage.setItem("hbscToken", this.productList[0].access_token);
          this.searchUserAddrList();
          this.getUserInfo();
        }else{
          this.searchUserAddrList();
        }
      }

      if (this.productList[0].isOrderTip == "1") {
        this.tipShow = true;
      }
      // if (
      //   sessionStorage.getItem("memberId") == "2015745680" ||
      //   this.$cookies.get("memberId") == "2015745680"
      // ) {
      //   alert(this.productList);
      // }
      if (
        this.productList[0].couponCode &&
        this.productList[0].couponCode != ""
      ) {
        (this.couponSource = 1), (this.couponOrderType = 1);
      }
      var flag = this.productList.some(function (value) {
        // console.log(value);
        return value.isGivePlus == "1";
      });
      if (flag) {
        this.qyshow = true;
      }
      if (
        this.$route.query.sources != "1" &&
        this.productList[0].applyCode == null
      ) {
        this.productList.map((value) => {
          this.totalPoint += value.point * value.number;
          this.totalAmount += value.number;
        });
      } else {
        this.totalAmount = 1;
        this.payType = "卡兑换";
      }
      if (this.query.sourceCenter === 'article') {
        this.payType = '卡兑换';
        this.totalPoint = 0;
      }
    },

    // 查看服务协议
    goProtocol() {
      // https://wbh5.dreamane.com/#/my/serviceAgreement
      // wx.miniProgram.navigateTo({
      //   url:
      //     "/pages/cashier/cashier?amount=" +
      //     that.data.shopInfo.buyPayAmount +
      //     "&orderNo=" +
      //     res.data,
      // });
      this.$router.push({
        path: "/my/serviceAgreement",
      });
    },
    //查询优惠券信息
    async queryCouponPerSon() {
      const param = {
        limit: 10,
        start: 1,
        status: 1,
      };
      const res = await queryMyCoupon(param);
      if (res.code == "0000") {
        this.hasCoupon = true;
        this.couponAmount = "去选择优惠券";
      } else {
        this.$toast(res.msg);
      }
    },
    /**
     * Puxigui
     * 切换地址
     * 2:14 2020/11/20
     */
    tabAddress() {
      var params = {
        address: this.address[this.addressIndex],
        productList: this.$route.query.productList,
        sources: this.$route.query.sources || 0,
        orderType: this.couponOrderType,
      };
      // console.log(this.productList);
      params.status = "submitOrder";
      // wx.navigateTo({
      //     url: '../../pages/web-view/web-view?' + "src=" + encodeURIComponent(url)
      // })
      if (this.query.sourceCenter !== 'article') {
        this.$router.push({
          path: "/orders/shippingAddress",
          query: {
            ...params,
          },
        });
      }else{
        const json = {
          ...this.query,
          ...params
        }
        this.$router.push({
          path: "/orders/shippingAddress",
          query: {
            ...json,
          },
        });
      }

    },
    showModal(name) {
      this.modalName = name;
    },
    toMyCoupon() {
      if (this.hasCoupon) {
        this.$router.push({
          path: "/my/orderCoupon",
          query: {
            goodsId: this.goodsId,
            goodsNum: this.goodsNum,
            totalAmount: this.shopInfo.buyTotalAmount,
            addressId: this.addressId,
          },
        });
      }
    },
    sendcode() {
      this.totaltime = 60;
      this.sendtimer();
      this.sendMsg();
    },
    async upperFindTotalPoint() {
      //获取总积分
      let params = {};
      let totalRes = await totalPoint(params);
      if (totalRes.code == "0000") {
        this.userPoint = totalRes.data;
      }
    },
    sendtimer() {
      if (this.totaltime > 0) {
        this.disabled = true;
        this.totaltime--;
        this.vocode = this.totaltime + "s后重新发送";
        setTimeout(this.sendtimer, 1000);
      } else {
        this.totaltime = 0;
        this.vocode = "重新发送验证码";
        this.disabled = false;
      }
      // this.sendMsg();
      // let clock = window.setInterval(() => {
      //     this.totaltime--
      //     this.vocode = this.totaltime + 's后重新发送'
      //     if (this.totaltime == 0) {
      //         window.clearInterval(clock)
      //         this.vocode = '重新发送验证码'
      //         this.totaltime = 60
      //     }
      // }, 1000)
    },
    //发送验证码
    async sendMsg() {
      const param = {
        memberId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        msgParameter: {
          code: this.code,
        },
        phoneNo:
          this.$cookies.get("memberPhone") ||
          sessionStorage.getItem("memberPhone"),
        sysMessageTemplateId: 1,
      };
      const res = await sendMsg(param);
      if (res.code == "0000") {
        this.$toast("发送成功");
      }
    },
    //自然月短信校验
    async haierOrderCount() {
      let params = {
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
      };
      let res = await haierOrderCount(params);
      if (res.code == "0000") {
        this.OrderCount = res.data;
      }
    },

    invoice() {
      const that = this;
      this.$router.push({
        path: "/orders/invoice",
        query: {
          goodsId: that.goodsId,
          goodsNum: that.goodsNum,
          addressId: that.addressId,
          couponId: that.couponId,
        },
      });
    },
    agreementBind() {
      this.agreement = !this.agreement;
    },

    async subPay() {
      console.log(this.$route.query.sources)
      console.log(this.userPoint)
      console.log(this.totalPoint)
      if (
        this.$route.query.sources != "1" &&
        this.userPoint < this.totalPoint
      ) {
        this.$toast("积分不足！");
        return;
      }
      //验证验证码
      if (this.OrderCount < 1) {
        const param = {
          key:
            (this.$cookies.get("memberPhone") ||
              sessionStorage.getItem("memberPhone")) +
            "-" +
            1 +
            "-" +
            this.code,
          code: this.code,
        };
        const res = await verifyCodeMemberReceived(param);
        if (res.code == "0000") {
          // this.$toast("验证码正确");
        } else if (this.code == "") {
          this.$toast("验证码为空");
          return false;
        } else {
          this.$toast("验证码错误");
          return false;
        }
      }

      if (
        this.address.length == 0 ||
        this.address[this.addressIndex].address.province_id == null ||
        this.address[this.addressIndex].address.district_id == null ||
        this.address[this.addressIndex].address.city_id == null
      ) {
        this.$toast("地址信息不完整，请重新录入");
        return false;
      }
      if (!this.agreement) {
        this.$toast("请阅读注意事项");
        return false;
      }
      this.$store.commit("showLoading");
      this.commitOrder();
    },
    hideModal() {
      this.modalName = "";
    },
    //提交订单
    async commitOrder() {
      let this_ = this;

      let params = {};
      //存储商品详情数组
      let goodsList = [];
      for (let i = 0; i < this.productList.length; i++) {
        // console.log(this.productList[i]);
        //检验地区
        params = {
          productId: this.productList[i].id, //商品ID--》规格id
          provinceId: this.address[this.addressIndex].address.province_id, //省份id
          cityId: this.address[this.addressIndex].address.city_id, //市级id
          areaId: this.address[this.addressIndex].address.district_id, //区县id
        };
        if (this.productList[i].isPlus == 1) {
          this.isPlus = 1;
        }
        let res = await haierOrderCheckArea(params);
        if (res.code != "0000") {
          this.$store.commit("hideLoading");

          this.$message(res.msg);
          return;
        }
        this.$store.commit("hideLoading");
        this.$store.commit("showLoading");

        let arr =
          this.address[this.addressIndex].address.province +
          " " +
          this.address[this.addressIndex].address.city +
          " " +
          this.address[this.addressIndex].address.district;
        //校验库存
        params = {
          goodsId: this.productList[i].id, //商品ID
          quantity: this.productList[i].number, //购买数量
          thirdProductCode: this.productList[i].thirdProductCode,
          area: arr,
        };
        if (this.$route.query.sources != "1") {
          res = await haierOrderCheckQuantity(params);

          if (res.code != "0000") {
            this.$store.commit("hideLoading");
            this.$message(res.msg);
            return;
          }
        }

        this.$store.commit("hideLoading");
        this.$store.commit("showLoading");

        //组装订单详细数据
        let goods = {};
        goods.supplierCode = this.productList[i].supplierCode;
        goods.supplierName = this.productList[i].supplierName;
        goods.supplierV = this.productList[i].supplierV;
        goods.goodsId = this.productList[i].id;
        goods.goodsCode = this.productList[i].code;
        goods.goodsName = this.productList[i].name;
        goods.goodsImgUrl = this.productList[i].goodsImgUrl;
        goods.quantity = this.productList[i].number;
        goods.integralPrice = this.productList[i].point;
        goods.mark = this.mark;
        goodsList.push(goods);
        // console.log(goods, i);
      }
      let xsource;
      if (
        this.productList[0].couponCode &&
        this.productList[0].couponCode != ""
      ) {
        xsource = 1;
      } else {
        xsource = this.$route.query.sources || 0;
      }
      params = {
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        buyerUsername: "123",
        receiverName: this.address[this.addressIndex].receiver_name,
        receiverPhone: this.address[this.addressIndex].receiver_mobile,
        receiverProvinceId: this.address[this.addressIndex].address.province_id,
        receiverProvinceName: this.address[this.addressIndex].address.province,
        receiverCityId: this.address[this.addressIndex].address.city_id,
        receiverCityName: this.address[this.addressIndex].address.city,
        receiverCountryId: this.address[this.addressIndex].address.district_id,
        receiverRegionName: this.address[this.addressIndex].address.district,
        receiverAddress: this.address[this.addressIndex].address.line1,
        sources: xsource,
        orderType: this.couponOrderType,
        createOrderRequestList: goodsList,
        couponCode: this.productList[0].couponCode || 0,
        activityCode: this.productList[0].activityCode || 0,
        pointCardNo: this.productList[0].couponCode || null,
      };
      console.log(this.productList);
      if (this.productList[0].applyCode != null) {
        (params.applyCode = this.productList[0].applyCode),
          (params.pointCardNo = this.productList[0].cardNo),
          (params.sources = 2);
        params.orderType = 1;
        let res = await giftVoucherHaierCreateOrder(params);
        if (res.code == "0000") {
          //删除购物车内容
          this.$router.push({
            path: "/orders/paymentSuccessful",
            query: {
              parentOrderNo: res.data,
              saleTotalAmount: this.totalPoint,
              applyCode: this.productList[0].applyCode,
              sources:this.$route.query.sources||0
            },
          });
        } else {
          this.$store.commit("hideLoading");
          this.$toast(res.msg);
        }
      } else {
        if (this.query.sourceCenter === 'article') {
          let json = {
            ...params,
            buyerId: this.query.userId,
            activityNo: this.query.activityNo,
            // productId: productId,
            shareList: JSON.parse(decodeURIComponent(this.query.shareList)),
            userInterestsId: this.query.userInterestsId,
            giftPackageId: this.query.giftPackageId,
            orderType: 1,
            sources: 2
          };
          this.query.productId ? json.productId = this.query.productId : null;
          let res = await haierCreateOrder(json);
          if (res.code == "0000") {
            this.$store.commit("hideLoading");
            this.$toast('操作成功');
            let hzyUrl = ''
            if(window.location.origin!=='https://jf.haier.com'){
              hzyUrl = 'test'
            }
            window.location.href=`https://hzy${hzyUrl}.haier.com/cn/vipcode/prizeSuccess?rightsId=${this.query.activityNo}`
          } else {
            this.$store.commit("hideLoading");
            this.$toast(res.msg);
          }
        }else{
          let res = await haierCreateOrder(params);
          if (res.code == "0000") {
            //删除购物车内容
            if (this.$route.query.crat != null && this.$route.query.crat == 1) {
              for (let i = 0; i < this.productList.length; i++) {
                let params = {};
                this_.deleteList.userId =
                  this.$cookies.get("memberId") ||
                  sessionStorage.getItem("memberId");
                this_.deleteList.skuId = this.productList[i].id;
                params = this_.deleteList;
                const res = await haierDelShoppingCart(params);
                if (res.code == "0000") {
                  console.log(this.productList[i].id + "商品，购物车清除成功！");
                }
              }
            }

            this.parentOrderNo = res.data;
            if (this.$route.query.sources == "1") {
              this.$router.push({
                path: "/orders/paymentSuccessful",
                query: {
                  parentOrderNo: res.data,
                  saleTotalAmount: this.totalPoint,
                },
              });
            }
            this.show = true;
          } else {
            this.$store.commit("hideLoading");
            this.$toast(res.msg);
          }
        }
      }
      this.$store.commit("hideLoading");
    },
    // async haierOrderShoppingCart() {
    //     for (let i = 0; i < this.productList.length; i++) {
    //         console.log(this.productList[i])

    //         let params = {
    //             userId: this.$cookies.get("memberId") || sessionStorage.getItem('memberId'),
    //             productId: this.productList[i].productId, //商品ID
    //             amount: "-" + this.productList[i].number, //商品ID

    //         };

    //         const res = await haierOrderShoppingCart(params);
    //         if (res.code == "0000") {
    //             console.log("11111")
    //         }
    //     }

    // },
    //立即付款
    async goPay() {
      this.$store.commit("showLoading");

      // let params = {
      //     orderNo: this.orderNo,
      // }
      // console.log(this.orderNo)

      // let res = await selHaierOrderOverdue(params);
      // if (res.code == "0000") {
      //     this.time = new Date(res.data) - new Date().getTime()
      // }
      let params = {
        buyerId:
          this.$cookies.get("memberId") || sessionStorage.getItem("memberId"),
        payTotalAmount: this.totalPoint,
        parentOrderNo: this.parentOrderNo,
        phone:
          this.$cookies.get("memberPhone") ||
          sessionStorage.getItem("memberPhone"),
      };
      let res = await haierOrderPay(params);
      if (res.code === "0000") {
        this.$toast("支付成功");
        // console.log(this.isPlus)

        //  if (this.isPlus == 1) {
        this.$router.push({
          path: "/orders/paymentSuccessful",
          query: {
            parentOrderNo: this.parentOrderNo,
            saleTotalAmount: this.totalPoint,
            isPlus: this.isPlus,
            sources:this.$route.query.sources||0
          },
        });
        // }else{
        //   this.$router.push({
        //     path: "/order",
        //     query: {
        //       order: "123456",
        //     },
        //   });
        // }
      } else {
        // this.$toast(res.msg);
      }
      this.$store.commit("hideLoading");
    },
    //查询用户地址列表
    async searchUserAddrList() {
      let params = {};
      let res = await searchUserAddrList(params);
      if (res.code == "0000") {
        if (res.data[0] == null) {
          this.address = [];
        } else {
          this.address = res.data;
        }
      }
    },

    //订单过期时间
    // async selHaierOrderOverdue() {
    //     console.log("1111111")
    //     let params = {
    //         orderNo: this.orderNo,
    //     }

    //     const res = await selHaierOrderOverdue(params);
    //     if (res.code == "0000") {
    //         console.log(res)
    //     }
    // },

    // goWebview() {
    //   var that = this;
    //   //调用下单接口
    //   var param = {};
    //   param.couponIds = [""];
    //   param.settleNum = this.shopInfo.settleNum;
    //   param.shoppingCartId = this.shopInfo.shoppingCartId;
    //   param.receiverProvinceName = this.address.addressProvinceId;
    //   param.receiverCityName = this.address.addressCityId;
    //   param.receiverRegionName = this.address.addressRegionId;
    //   param.receiverName = this.address.consigneeName;
    //   param.receiverPhone = this.address.phone;
    //   param.receiverAddress = this.address.addressDetail;
    //   param.invoiceId = this.invoiceId;
    //   param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
    //   param.saleTotalAmount = this.shopInfo.buyTotalAmount;
    //   param.discountTotalAmount = this.discountAmount;
    //   //如果是秒杀商品，发起请求生成秒杀订单，如果是拼团，发起拼团订单，否则生成普通商品订单
    //   if (this.orderType == "seckill") {
    //     param.buyTotalAmount = this.shopInfo.buyTotalAmount;
    //     param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
    //     param.buyNum = this.goodsNum;
    //     param.mpId = this.goodsId;
    //     param.promotionId = this.promotionId;
    //     param.promotionType = 4;
    //     createSpikeOrder(param, function (res) {
    //       if (res.code == "0000") {
    //         wx.miniProgram.navigateTo({
    //           url:
    //             "/pages/cashier/cashier?amount=" +
    //             that.data.shopInfo.buyPayAmount +
    //             "&orderNo=" +
    //             res.data,
    //         });
    //       }
    //     });
    //   } else if (this.orderType == "group") {
    //     param.buyTotalAmount = this.shopInfo.buyTotalAmount;
    //     param.actualPayTotalAmount = this.shopInfo.buyPayAmount;
    //     param.buyNum = this.goodsNum;
    //     param.goodsId = this.goodsId;
    //     param.groupId = this.groupId;
    //     param.groupInstCode = this.groupInstCode;
    //     param.launchFlag = this.groupType;
    //     param.promotionType = this.promotionType;
    //     createJoinGroupOrder(param, function (res) {
    //       if (res.code == "0000") {
    //         if (that.shopInfo.buyPayAmount == 0) {
    //           setTimeout(() => {
    //             that.$router.push({
    //               path: "/orders/paymentSuccessful",
    //             });
    //           }, 1000);
    //         } else {
    //           wx.miniProgram.navigateTo({
    //             url:
    //               "/pages/cashier/cashier?amount=" +
    //               that.shopInfo.buyPayAmount +
    //               "&orderNo=" +
    //               res.data,
    //           });
    //         }
    //       }
    //     });
    //   } else {
    //     param.couponIds = [this.couponId];
    //     addOrderInfo(param).then((res) => {
    //       wx.miniProgram.redirectTo({
    //         url:
    //           "/pages/cashier/cashier?amount=" +
    //           that.shopInfo.buyPayAmount +
    //           "&orderNo=" +
    //           res.data +
    //           "&payType=" +
    //           this.shopInfo.payMeent,
    //       });
    //     });
    //   }
    // },

    /**
     * Puxigui
     *  查询用户地址信息
     * 19:06 2020/11/19
     */
    // async queryUserAddress() {
    //   let that = this;
    //   const param = {
    //     start: 1,
    //     limit: 10,
    //     id: this.addressId,
    //   };
    //   const res = await searchUserAddrList(param);
    //   if (res.code == "0000") {
    //     if (res.data.rows) {
    //       if (this.addressId) {
    //         res.data.rows.forEach(function (item) {
    //           if (item.id == that.addressId) {
    //             that.address = item;
    //             that.addressId = item.id;
    //           }
    //         });
    //       }
    //       res.data.rows.forEach(function (item) {
    //         if (item.isDefault == 1) {
    //           that.address = item;
    //           that.addressId = item.id;
    //         }
    //       });
    //       if (!this.addressId) {
    //         (this.address = res.data.rows[0] ? res.data.rows[0] : ""),
    //           (this.addressId = res.data.rows[0].id);
    //       }
    //     }
    //   } else {
    //     this.$toast(res.msg);
    //   }
    // },
    /**
     * Puxigui
     *  查询购物车下单信息
     * 19:32 2020/11/19
     */
    async queryProductInfo() {
      const param = {};
      const res = await shoppingCartSettlement(param);
      if (res.code == "0000") {
        this.shopInfo = res.data;
        this.shopInfo.buyPayAmount = res.data.buyTotalAmount;
      } else {
        this.$toast(res.msg);
      }
    },

    /**
     * Puxigui
     * 直接下单
     * 14:47 2020/11/20
     */
    async directSettle() {
      const param = {
        goodsId: this.goodsId,
        goodsNum: this.goodsNum,
        promotionId: this.promotionId,
        promotionType: this.promotionType,
        groupType: this.groupType,
        saleUnitPrice: this.saleUnitPrice,
      };
      if (this.promotionId && !param.groupType) {
        param.couponIds = [param.promotionType];
      }
      const res = await directSettle(param);
      if (res.code == "0000") {
        this.shopInfo = res.data;
        this.shopInfo.buyPayAmount = res.data.buyTotalAmount;
        if (res.data.productPropertyResponses) {
          var property = [];
          res.data.productPropertyResponses.forEach(function (item) {
            property.push(item.valueName);
          });
          this.property = property.join(",");
        }
        // this.preOrder();
      } else {
        this.$toast(res.msg);
      }
    },
    //商品预计算
    async preOrder() {
      var this_ = this;
      var array = [];
      if (this_.shopInfo && this_.shopInfo.shoppingCartSubInfoList) {
        this_.shopInfo.shoppingCartSubInfoList.forEach(function (item) {
          item.shoppingCartGoodsInfoList.forEach(function (item2) {
            var obj = {};
            obj.productId = item2.goodsId;
            obj.num = item2.goodsNum;
            array.push(obj);
          });
        });
      }
      const param = {
        couponId: this.data.couponId,
        isCart: 1,
        productOrders: array,
      };
      const res = await preOrder(param);
      if (res.code == "0000") {
        (this.shopInfo.buyPayAmount = res.data.payAmount),
          (this.shopInfo.buyTotalAmount = res.data.totalAmount),
          (this.discountAmount = res.data.discountAmount);
        if (this.couponId && "undefined" != this.couponId) {
          this.couponAmount = "-" + res.data.couponAmount;
        }
      } else {
        this.$toast(res.msg);
      }
    },
  },
  destroyed() {},

};
</script>

<style lang="scss" scoped>
html,
body {
  background-color: #fff;
}
.huoqu {
  width: 240px;
}

.tui-input {
  border: 1px solid #666;
  width: 180px;
  height: 60px;
  padding-left: 20px;
}

.tui-inputs {
  border: none;
  width: 90%;
  height: 80px;
  padding-left: 20px;
  font-size: 20px;
}

.tui-zhuyi {
  padding-left: 20px;
  font-size: 27px;
}

.tui-zhuyis {
  padding: 0 20px;
  font-size: 26px;
  // display: flex;
  align-items: center;
}

/**app.wxss**/

// .app {
$--themeColor: #ff5033;
$--themeColors: #d80c18;
$--themeColor2: #d80c18;
$--myColor: #1e53a4;

// }
.text-theme {
  --themeColor: #ff5033;
  --themeColor2: #d80c18;
}

.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 200px 0;
  box-sizing: border-box;
}

/* ==================
          布局
 ==================== */

/*  -- flex弹性布局 -- */

.flex {
  display: flex;
}

.basis-xs {
  flex-basis: 20%;
}

.basis-sm {
  flex-basis: 40%;
}

.basis-df {
  flex-basis: 50%;
}

.basis-lg {
  flex-basis: 60%;
}

.basis-xl {
  flex-basis: 80%;
}

.flex-sub {
  flex: 1;
}

.flex-twice {
  flex: 2;
}

.flex-treble {
  flex: 3;
}

.flex-direction {
  flex-direction: column;
}

.flex-wrap {
  flex-wrap: wrap;
}

.align-start {
  align-items: flex-start;
}

.align-end {
  align-items: flex-end;
}

.align-center {
  align-items: center;
}

.align-stretch {
  align-items: stretch;
}

.self-start {
  align-self: flex-start;
}

.self-center {
  align-self: flex-center;
}

.self-end {
  align-self: flex-end;
}

.self-stretch {
  align-self: stretch;
}

.align-stretch {
  align-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

/* ==================
         模态窗口
 ==================== */

// .cu-modal {
//   position: fixed;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   z-index: 1110;
//   opacity: 0;
//   outline: 0;
//   text-align: center;
//   -ms-transform: scale(1.185);
//   transform: scale(1.185);
//   backface-visibility: hidden;
//   perspective: 2000rpx;
//   background: rgba(0, 0, 0, 0.6);
//   transition: all 0.3s ease-in-out 0s;
//   pointer-events: none;
// }

// .cu-modal::before {
//   content: "\200B";
//   display: inline-block;
//   height: 100%;
//   vertical-align: middle;
// }

// .cu-modal.show {
//   opacity: 1;
//   transition-duration: 0.3s;
//   -ms-transform: scale(1);
//   transform: scale(1);
//   overflow-x: hidden;
//   overflow-y: auto;
//   pointer-events: auto;
// }

// .cu-dialog {
//   position: relative;
//   display: inline-block;
//   vertical-align: middle;
//   margin-left: auto;
//   margin-right: auto;
//   width: 610rpx;
//   max-width: 100%;
//   background-color: #f8f8f8;
//   border-radius: 20rpx;
//   overflow: hidden;
// }

// .cu-modal.bottom-modal::before {
//   vertical-align: bottom;
// }

// .cu-modal.bottom-modal .cu-dialog {
//   width: 100%;
//   border-radius: 20rpx;
// }

// .cu-modal.bottom-modal {
//   margin-bottom: -1000rpx;
// }

// .cu-modal.bottom-modal.show {
//   margin-bottom: 0;
// }

// .cu-modal.drawer-modal {
//   transform: scale(1);
//   display: flex;
// }

// .cu-modal.drawer-modal .cu-dialog {
//   height: 100%;
//   min-width: 200rpx;
//   border-radius: 0;
//   margin: initial;
//   transition-duration: 0.3s;
// }

// .cu-modal.drawer-modal.justify-start .cu-dialog {
//   transform: translateX(-100%);
// }

// .cu-modal.drawer-modal.justify-end .cu-dialog {
//   transform: translateX(100%);
// }

// .cu-modal.drawer-modal.show .cu-dialog {
//   transform: translateX(0%);
// }

// .cu-modal .cu-dialog > .cu-bar:first-child .action {
//   min-width: 100rpx;
//   margin-right: 0;
//   min-height: 100rpx;
// }
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}

.block {
  display: inline-block;
  width: 52px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}

// ------------------------------
// .containers {
//   background-color: #f5f6f5;
// }

.bg-white {
  background-color: #ffffff;
}

.round-20 {
  border-radius: 20px;
}

.tui-box {
  padding: 0 0 158px;
  box-sizing: border-box;
  background-color: #fff;
}

.padding-right-xs {
  padding-right: 10px;
}

.tips {
  font-size: 24px;
  width: 70%;
  text-align: left;
  padding: 24px;
  color: #999999;
  height: 120px;
}

.tui-address {
  min-height: 170px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: #fff;
  position: relative;
}

.address-image {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}

.right-image {
  width: 15px;
  height: 26px;
}

.address-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.tui-userinfo {
  font-size: 36px;
  font-weight: 500;
  color: #333;
  padding-bottom: 12px;
}

.tui-name {
  padding-right: 40px;
}

.tui-addr {
  font-size: 26px;
  word-break: break-all;
  color: #666;
  width: 534px;
}

.tui-addr-tag {
  padding: 5px 8px;
  flex-shrink: 0;
  background: #eb0909;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  line-height: 25px;
  transform: scale(0.8);
  transform-origin: 0 center;
  border-radius: 6px;
}

.tui-bg-img img {
  width: 100%;
  height: 8px;
  position: absolute;
  bottom: -10px;
  left: 0;
}

.tui-top {
  margin-top: 20px;
  overflow: hidden;
}

.tui-goods-info {
  margin: 30px 20px;
}

.tui-goods-title {
  font-size: 26px;
  display: flex;
  align-items: center;
  color: #333333;
  padding: 20px 0 0 20px;
}

.tui-padding {
  padding: 30px 20px;
}

.tui-goods-item {
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
}

.tui-goods-img {
  width: 180px;
  height: 180px;
  display: block;
  flex-shrink: 0;
  border-radius: 10px;
}

.tui-goods-center {
  flex: 1;
  padding: 16px 10px 16px 22px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tui-goods-name {
  max-width: 90%;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 26px;
  line-height: 32px;
  color: #333333;
}

.tui-goods-attr {
  font-size: 22px;
  // color: #888888;
  padding-top: 5px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.tui-price-right {
  font-size: 22px;
  // color: #666666;
  display: flex;
  justify-content: space-between;
}

.goods-price {
  font-size: 22px;
  font-weight: 500;
  span {
    color: red;
  }
}

.tui-goods-bottom {
  margin-left: 200px;
  font-size: 20px;
  color: #999999;
  margin-top: 20px;
}

.tui-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 26px;
}

.tui-pr-30 {
  padding-right: 30px;
}

.tui-addr-img {
  width: 36px;
  height: 46px;
  display: block;
  margin-right: 15px;
}

.tui-black {
  color: #333;
  line-height: 30px;
  padding-right: 10px;
}

.tui-price-large {
  // font-size: 34px;
  // line-height: 32px;
  // font-weight: 600;
  color: $--themeColors;
}

.tui-price-large::before {
  // content: "¥";
  font-size: 20px;
  color: $--themeColors;
}

/* 底部 */
.tui-tabbar {
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  font-size: 26px;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: 999;
}

.reminder {
  height: 70px;
  background: #fdf1f1;
  font-size: 26px;
  color: $--themeColors;
  line-height: 70px;
  padding-left: 20px;
}

.tabbar-discounts {
  font-size: 20px;
  color: #666666;
}

.tui-pr25 {
  padding-right: 30px;
}

.text-blue {
  color: #758dbf;
}

.padding-left {
  padding-left: 20px;
}

.btn-pay {
  width: 226px;
  height: 76px;
  background: $theme-color-main;
  border-radius: 38px;
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  color: #fff;
  line-height: 76px;
}

/* 支付弹框 */
.pay-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pay-type {
  height: 100px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 24px;
  font-size: 26px;
  color: #333333;
}

.pay-title {
  font-size: 28px;
  padding: 22px 0 40px 0;
}

.pay-price {
  font-size: 26px;
  color: #999999;
}

.pay-money {
  font-size: 46px;
  padding: 20px;
}

.pay-time {
  font-size: 26px;
  color: $--themeColor;
}

.pay-but {
  width: 580px;
  height: 88px;
  background: $theme-color-main;
  border-radius: 43px;
  font-size: 28px;
  text-align: center;
  color: #ffffff;
  line-height: 88px;
  margin-top: 200px;
  margin-bottom: 30px;
}

.pay-icon {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.tag {
  background: #fdf1f1;
  border-radius: 5px;
  font-size: 20px;
  color: $--themeColors;
  padding: 2px 5px;
}

/* 运费 */
.freight {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  color: #333333;
  padding: 20px;
}

.freight-but {
  width: 750px;
  height: 88px;
  background: $--themeColors;
  font-size: 36px;
  text-align: center;
  color: #ffffff;
  line-height: 88px;
  position: fixed;
  bottom: 0;
  padding-bottom: env(safe-area-inset-bottom);
}

/* 失效商品 */
.goods {
  display: flex;
  align-items: center;
  font-size: 26px;
  color: #333333;
  padding: 20px;
}

.goods img {
  width: 115px;
  height: 115px;
  border-radius: 10px;
}

.goods text {
  margin-left: 26px;
}

.lose-button {
  display: flex;
  border-top: 1px solid #dddddd;
}

.confirm {
  padding: 30px;
  color: #ffffff;
  background: $--themeColors;
  flex: 1;
}

.cancel {
  padding: 30px;
  flex: 1;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.tui-none-addr {
  font-size: 26px;
  color: #666666;
}
.border-bottom {
  border-bottom: 4px solid #f9f9f9;
}
.tui-tip {
  color: #8c8c8c;
  justify-content: space-around;
}
.padding-left-xs {
  font-size: 24px;
}
.tui-receiving {
  padding: 30px 20px;
  color: #999999;
  font-size: 0.4rem;
  text-align: left;
  line-height: 0.6rem;
}
.tui-qy {
  padding: 30px 50px;
  color: #999999;
  font-size: 0.3rem;
  text-align: left;
  line-height: 0.5rem;
  span {
    font-size: 0.35rem;
    color: #000;
  }
}
.qy {
  display: flex;
  justify-content: space-between;
}
.qybox {
  font-size: 0.35rem;
  padding-right: 20px;
  .b {
    color: var(--theme-color-main);
    text-decoration: underline;
  }
  .c {
    color: red;
  }
  .bz {
    color: #999;
    font-size: 0.25rem;
  }
}
/deep/.van-dialog__header {
  padding-top: 20px;
}
/deep/.van-dialog--round-button .van-dialog__footer {
  padding: 30px 100px;
}
</style>
